<div class="dsd">
  <div class="dsd-header">
    <h3 class="dsd-title">{{ title }}</h3>
    <button class="dsd-close" (click)="cancel()"><i class="bi bi-x-lg"></i></button>
  </div>

  <div class="dsd-tabs">
    <button class="dsd-tab" [class.dsd-tab-active]="tab === 'style'" (click)="tab = 'style'">Estilo</button>
    <button class="dsd-tab" [class.dsd-tab-active]="tab === 'coords'" (click)="tab = 'coords'">Coordenadas</button>
    <button class="dsd-tab" [class.dsd-tab-active]="tab === 'visibility'" (click)="tab = 'visibility'">Visibilidad</button>
  </div>

  <div class="dsd-body">

    <!-- ── Estilo ── -->
    <ng-container *ngIf="tab === 'style'">
      <div class="dsd-row">
        <label>Color de línea</label>
        <div class="dsd-palette">
          <div class="dsd-pal-row" *ngFor="let row of palette">
            <button *ngFor="let color of row" class="dsd-pal-cell"
              [style.background]="color"
              [class.dsd-pal-active]="color === lineColor"
              (click)="lineColor = color; applyStyle()"></button>
          </div>
        </div>
      </div>

      <div class="dsd-row">
        <label>Grosor</label>
        <select [(ngModel)]="lineWidth" (ngModelChange)="applyStyle()">
          <option [ngValue]="1">1 px</option>
          <option [ngValue]="2">2 px</option>
          <option [ngValue]="3">3 px</option>
          <option [ngValue]="4">4 px</option>
        </select>
      </div>

      <div class="dsd-row">
        <label>Estilo de línea</label>
        <select [(ngModel)]="lineDashKey" (ngModelChange)="applyStyle()">
          <option value="solid">Sólida</option>
          <option value="dashed">Discontinua</option>
          <option value="dotted">Punteada</option>
        </select>
      </div>

      <ng-container *ngIf="meta?.hasFill">
        <div class="dsd-row">
          <label>Color de relleno</label>
          <input type="color" [(ngModel)]="fillColor" (ngModelChange)="applyStyle()">
        </div>
        <div class="dsd-row">
          <label>Opacidad de relleno</label>
          <input type="range" min="0" max="1" step="0.05" [(ngModel)]="fillOpacity" (ngModelChange)="applyStyle()">
          <span class="dsd-value">{{ fillOpacity | number:'1.2-2' }}</span>
        </div>
      </ng-container>

      <div class="dsd-row">
        <label class="dsd-check">
          <input type="checkbox" [(ngModel)]="showLabels" (ngModelChange)="applyStyle()">
          Mostrar etiquetas
        </label>
      </div>

      <!-- Campos específicos del tipo -->
      <ng-container *ngFor="let field of extraFields">
        <ng-container [ngSwitch]="field.kind">

          <div class="dsd-row" *ngSwitchCase="'checkbox'">
            <label class="dsd-check">
              <input type="checkbox" [(ngModel)]="extraValues[field.key]" (ngModelChange)="applyField(field)">
              {{ field.label }}
            </label>
          </div>

          <div class="dsd-row" *ngSwitchCase="'number'">
            <label>{{ field.label }}</label>
            <input type="number" [(ngModel)]="extraValues[field.key]" (ngModelChange)="applyField(field)"
              [min]="field.min ?? null" [max]="field.max ?? null" [step]="field.step ?? 1">
          </div>

          <div class="dsd-row" *ngSwitchCase="'text'">
            <label>{{ field.label }}</label>
            <input type="text" [(ngModel)]="extraValues[field.key]" (ngModelChange)="applyField(field)">
          </div>

          <div class="dsd-row dsd-row-block" *ngSwitchCase="'textarea'">
            <label>{{ field.label }}</label>
            <textarea rows="3" [(ngModel)]="extraValues[field.key]" (ngModelChange)="applyField(field)"></textarea>
          </div>

          <div class="dsd-row" *ngSwitchCase="'color'">
            <label>{{ field.label }}</label>
            <input type="color" [(ngModel)]="extraValues[field.key]" (ngModelChange)="applyField(field)">
          </div>

          <div class="dsd-row" *ngSwitchCase="'select'">
            <label>{{ field.label }}</label>
            <select [(ngModel)]="extraValues[field.key]" (ngModelChange)="applyField(field)">
              <option *ngFor="let opt of field.options" [ngValue]="opt.value">{{ opt.label }}</option>
            </select>
          </div>

          <div class="dsd-row dsd-row-block" *ngSwitchCase="'levels'">
            <label>{{ field.label }}</label>
            <div class="dsd-levels">
              <div class="dsd-level" *ngFor="let level of levels; let i = index; trackBy: trackByIndex">
                <input type="number" step="0.001" [(ngModel)]="levels[i]" (change)="applyLevels()">
                <button class="dsd-level-del" (click)="removeLevel(i)" title="Quitar nivel">
                  <i class="bi bi-x"></i>
                </button>
              </div>
              <div class="dsd-level-actions">
                <button (click)="addLevel()"><i class="bi bi-plus-lg"></i> Añadir</button>
                <button (click)="resetLevels()"><i class="bi bi-arrow-counterclockwise"></i> Restablecer</button>
              </div>
            </div>
          </div>

        </ng-container>
      </ng-container>
    </ng-container>

    <!-- ── Coordenadas ── -->
    <ng-container *ngIf="tab === 'coords'">
      <div class="dsd-anchor" *ngFor="let anchor of anchors; let i = index">
        <span class="dsd-anchor-num">#{{ i + 1 }}</span>
        <div class="dsd-anchor-fields">
          <label>Precio
            <input type="number" step="any" [(ngModel)]="anchor.price" (change)="applyAnchors()">
          </label>
          <label>Fecha
            <input type="datetime-local" [(ngModel)]="anchor.datetime" (change)="applyAnchors()">
          </label>
        </div>
      </div>
    </ng-container>

    <!-- ── Visibilidad ── -->
    <ng-container *ngIf="tab === 'visibility'">
      <div class="dsd-row">
        <label class="dsd-check">
          <input type="checkbox" [(ngModel)]="visible" (ngModelChange)="applyVisibility()">
          Visible
        </label>
      </div>
      <div class="dsd-row">
        <label class="dsd-check">
          <input type="checkbox" [(ngModel)]="locked" (ngModelChange)="applyVisibility()">
          Bloqueado
        </label>
      </div>
      <div class="dsd-row">
        <label>Orden (z-index)</label>
        <input type="number" [(ngModel)]="zIndex" (ngModelChange)="applyVisibility()">
      </div>
    </ng-container>

  </div>

  <div class="dsd-footer">
    <button class="dsd-btn" (click)="cancel()">Cancelar</button>
    <button class="dsd-btn dsd-primary" (click)="accept()">Aceptar</button>
  </div>
</div>
